<form [formGroup]="configGeneralForm" *transloco="let t; read: 'configuration-general-component'">
  <section class="configuration-general__group">
    <div class="configuration-general__section-title">
      <h5>{{ t('basic-options') }}</h5>
      <p>{{ t('basic-settings') }}</p>
    </div>
    <div class="configuration-general__section-center-form">
      <div class="configuration-general__input-wrapper">
        <label class="configuration-general__name-label" for="configuration-general__title">{{
          t('title')
        }}</label>
        <xi-input-field
          inputId="configuration-general__title"
          formControlName="configName"
          [status]="configNameStatus"
          required
        ></xi-input-field>
      </div>
      <div class="configuration-general__input-wrapper">
        <label for="configuration-general__description">{{ t('description') }}</label>
        <xi-text-area
          inputId="configuration-general__description"
          formControlName="configDescription"
        ></xi-text-area>
      </div>
    </div>
    <div
      class="configuration-general__description-toggle-switch"
      matTooltip="{{ t('toggle-tooltip-desc') }}"
    >
      <xi-toggle-switch
        leftText="{{ t('hide') }}"
        rightText="{{ t('show') }}"
        aria-label="{{ t('hide-show-label') }}"
        type="button"
        [isToggled]="newForm.showConfigDescription"
        [disabled]="isReadOnly()"
        (onToggle)="onToggleShowDescription($event.detail.isToggled)"
      ></xi-toggle-switch>
    </div>
  </section>

  <section class="configuration-general__group configuration-general__tags-section">
    <div class="configuration-general__section-title">
      <h5>{{ t('tags') }}</h5>
      <p>{{ t('tag-headers') }}</p>
    </div>
    <div class="configuration-general__section-center-form">
      <app-tag-editor
        [tags]="newForm.configTags"
        [editable]="!origConfiguration().removed && !isReadOnly()"
        [removable]="!origConfiguration().removed && !isReadOnly()"
        (tagAdded)="onTagAdded($event)"
        (tagRemoved)="onTagRemoved($event)"
        class="configuration-details__tags configuration-details__tags--manual"
      ></app-tag-editor>
    </div>
    <div
      class="configuration-general__tags-toggle-switch"
      matTooltip="{{ t('toggle-tooltip-tags') }}"
    >
      <xi-toggle-switch
        leftText="{{ t('hide') }}"
        rightText="{{ t('show') }}"
        aria-label="{{ t('hide-show-tag-label') }}"
        type="button"
        [isToggled]="newForm.showConfigTags"
        [disabled]="isReadOnly()"
        (onToggle)="onToggleShowTags($event.detail.isToggled)"
      ></xi-toggle-switch>
    </div>
  </section>
</form>
